import Send from '@mui/icons-material/Send';
import { LoadingButton } from "@mui/lab";
import { IoMdSave } from "react-icons/io";

/**
 * Primary loading/save button — indigo design system.
 */
export default function LoadingButtonCustom({
  title = "Sauvegarder",
  editMode = false,
  labelButton = null,
  handleUpdate = () => {},
  handleSubmit,
  loading,
  disabled = false,
  reload = () => {},
}) {
  const handle = () => {
    (editMode ? handleUpdate : handleSubmit)();
    reload(true);
  };

  const isDanger = labelButton != null;

  return (
    <LoadingButton
      loading={loading}
      onClick={handle}
      loadingPosition="center"
      variant="contained"
      autoFocus
      disabled={loading || disabled}
      type="submit"
      sx={{
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 600,
        fontFamily: "'Fira Sans', sans-serif",
        fontSize: '1rem',
        px: isDanger ? 2 : 3,
        py: isDanger ? 0.75 : 1,
        boxShadow: isDanger ? 'none' : '0 2px 8px rgba(3,64,123,0.28)',
        color: isDanger ? '#dc2626' : '#fff',
        background: isDanger
          ? '#fef2f2'
          : 'linear-gradient(135deg, #0556a4, #03407b)',
        border: isDanger ? '1px solid #fecaca' : 'none',
        '& .MuiCircularProgress-root': { color: isDanger ? '#dc2626' : '#fff' },
        '&:hover': {
          background: isDanger
            ? '#fee2e2'
            : 'linear-gradient(135deg, #03407b, #022d68)',
          boxShadow: isDanger ? 'none' : '0 4px 14px rgba(3,64,123,0.38)',
          transform: isDanger ? 'none' : 'translateY(-1px)',
        },
        '&:active': { transform: 'translateY(0)' },
        '&.Mui-disabled': {
          background: isDanger ? '#fef2f2' : '#aed6f1',
          color: isDanger ? '#fca5a5' : '#fff',
          boxShadow: 'none',
        },
      }}
      startIcon={
        isDanger ? undefined : title === "Envoyer" ? <Send /> : <IoMdSave />
      }
    >
      {labelButton != null ? labelButton : editMode ? "Modifier" : title}
    </LoadingButton>
  );
}
